import { render, staticRenderFns } from "./ReturnPack.vue?vue&type=template&id=71d52150"
import script from "./ReturnPack.vue?vue&type=script&lang=js"
export * from "./ReturnPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports